import Store from 'store/store';

Store.on('SET_UP_VERTICAL_TOUT_FILTERS', ({ pageId, filterCategories, ALL }) => {
	if (Store.get().toutVertical?.[pageId]) {
		return;
	}
	Store.get().set({
		toutVertical: {
			...Store.get().toutVertical,
			[pageId]: {
				selectedFilters: filterCategories?.length ? filterCategories.map(() => [ALL]) : []
			}
		}
	});
});

Store.on('VERTICAL_TOUT_CLEAR_FILTERS', ({ pageId, ALL }) => {
	if (!Store.get().toutVertical?.[pageId]) {
		return;
	}
	const existingFilters = Store.get().toutVertical[pageId].selectedFilters;

	Store.get().set({
		toutVertical: {
			...Store.get().toutVertical,
			[pageId]: {
				selectedFilters: existingFilters.map(() => [ALL])
			}
		}
	});

});

Store.on('VERTICAL_TOUT_FILTER_CLICK', ({ catIndex, filter, pageId, ALL }) => {
	if (!Store.get().toutVertical?.[pageId]) {
		return;
	}
	const existingFilters = Store.get().toutVertical[pageId].selectedFilters;
	Store.get().set({
		toutVertical: {
			...Store.get().toutVertical,
			[pageId]: {
				selectedFilters: existingFilters.map((items, index) => {
					if (filter == 'All') {
						return [ALL];
					} 
					if (items[0] == 'All') {
						items = [];
					}
					if (items.includes(filter)) {
						items = items.filter(item => item !== filter);
						if (items.length == 0) {
							return [ALL];
						}
					} else {
						items.push(filter);
					}				
					return items;
				})
			}
		}
	});
});